import { all, fork } from 'redux-saga/effects';

import app from './app';
import cart from './cart';
import checkout from './checkout';
import promocode from './promocode';
import search from './search';
import analytics from './analytics';
import locationNotify from './locationNotify';
import subscribe from './subscribe';
import wishList from './wishList';

export default function* rootSaga() {
    yield all([
        // order is important
        fork(app),
        fork(cart),
        fork(search),
        fork(checkout),
        fork(promocode),
        fork(analytics),
        fork(locationNotify),
        fork(subscribe),
        fork(wishList),
    ]);
}
